import {isProd} from 'app/config/config';

export const PROXY_BASE_URL = 'https://pg-uat.emap.co.nz/map/til_rest/75436_1234/streetmap_cl/rest/services';
export const GEOSPATIAL_BASEMAPS_AU_URL = isProd() ? 'https://geospatial-au-basemaps.api.cotality.com.au' : 'https://geospatial-au-basemaps.api-uat.cotality.com.au';
export const GEOSPATIAL_NZ_URL = isProd() ? 'https://geospatial-nz.api.cotality.co.nz' : 'https://geospatial-nz.api-uat.cotality.co.nz';
export const NEARMAP_OVERLAY = `${GEOSPATIAL_BASEMAPS_AU_URL}/nearmap/wmsCapability`;

export const STREET_BASEMAP = 'street';
export const NEARMAP = 'nearmap';
export const STREET_BASEMAP_URL = `${GEOSPATIAL_NZ_URL}/basemaps/streetmap`;

export const HYBRID_BASEMAP = 'hybrid';

export const AERIAL_BASEMAP = 'aerial';
export const AERIAL_BASEMAP_URL = `${GEOSPATIAL_NZ_URL}/basemaps/aerial`;
export const GEOMETRY_SERVICE_URL = `${GEOSPATIAL_NZ_URL}/utilities/geometry/GeometryServer`;

export const basemapsConfig = {
    [STREET_BASEMAP]: STREET_BASEMAP_URL,
    [AERIAL_BASEMAP]: AERIAL_BASEMAP_URL,
    [HYBRID_BASEMAP]: AERIAL_BASEMAP_URL,
    [NEARMAP]: NEARMAP_OVERLAY,
};

export const basemapBackgrounds = {
    [STREET_BASEMAP]: '#cdeaf8',
    [AERIAL_BASEMAP]: '#6687aa',
    [HYBRID_BASEMAP]: '#6687aa',
};